<template>
    <v-container fluid>
        <v-row no-gutters class="justify-center">
            <v-col cols="6" cols-xs="12">
                <v-card>
                    <v-card-title>
                        Change Password
                    </v-card-title>
                    <v-card-text>
                        <v-form
                            ref="form"
                            v-model="validForm"
                            :lazy-validation="false"
                        >
                            <v-text-field
                                v-model="password"
                                label="New password *"
                                :rules="passwordRules"
                                required
                                type="password"
                            ></v-text-field>
                            <v-text-field
                                v-model="passwordConfirm"
                                label="Confirm password *"
                                :rules="passwordConfirmRules"
                                required
                                type="password"
                                :error-messages="passwordConfirmErrors"
                            ></v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions class="px-4 flex-column">
                        <v-btn block color="primary" @click="onSubmitClick"
                            >Submit</v-btn
                        >

                        <v-btn
                            v-if="isUserAuthenticated"
                            text
                            block
                            class="mt-2"
                            @click="onCancelClick"
                            >Cancel</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';

export default {
    name: 'ChangePasswordPage',
    data() {
        return {
            validForm: false,
            password: '',
            passwordConfirm: '',
            passwordRules: [
                v => !!v || 'Password is required',
                v =>
                    (v && v.length <= 128) ||
                    'Password must be less than 10 characters'
            ],
            passwordConfirmRules: [
                v => !!v || 'Password is required',
                v =>
                    (v && v.length <= 128) ||
                    'Password must be less than 10 characters',
                v =>
                    v === this.password ||
                    'Confirmation password does not match Password'
            ],
            passwordConfirmErrors: []
        };
    },
    computed: {
        ...mapGetters('authUser', ['isUserAuthenticated']),
        ...mapState('brand', ['mso'])
    },
    methods: {
        ...mapActions('authUser', ['resetPassword']),
        onCancelClick() {
            this.$router.push({ name: 'homePage' });
        },
        async onSubmitClick() {
            if (this.$refs.form.validate()) {
                try {
                    await this.resetPassword({
                        password: this.password,
                        url: window.location.origin,
                        mso: this.mso
                    });
                    this.$store.dispatch('authUser/saveAuthToken', '');
                    this.$router.push({ name: 'loginPage' });
                } catch (error) {
                    if (
                        error.response.status === 400 ||
                        error.response.status === 404
                    ) {
                        this.passwordConfirmErrors =
                            error.response.data.message;
                    } else {
                        this.passwordConfirmErrors = 'Api call error!';
                    }
                }
            }
        }
    }
};
</script>
